import { gql } from '@apollo/client'
import { workOrderDocumentFragment } from './graphql'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import type { UpdateWorkOrderItemSerialNumbersArgs, WorkOrder } from '@ztechapps/common.contract'

export const updateWorkOrderItemSerialNumbersQuery = gql`
  mutation updateWorkOrderItemSerialNumbers($input: UpdateWorkOrderItemSerialNumbersArgs!) {
    updateWorkOrderItemSerialNumbers(input: $input) {
      ...workOrderDocumentFragment
    }
  }
  ${workOrderDocumentFragment}
`

export const useUpdateWorkOrderItemSerialNumbers = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, UpdateWorkOrderItemSerialNumbersArgs> => {
  query = query ?? updateWorkOrderItemSerialNumbersQuery

  return useActionMutation({
    query,
    ...props,
  })
}
